var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 22,
    viewBox: "0 0 55 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11485_6547)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 22,
    rx: 11,
    fill: "#00B960"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11485_6547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7939 8.33887C19.139 8.31934 19.4596 8.28678 19.7559 8.24121C20.0521 8.19564 20.3158 8.10775 20.5469 7.97754C20.7812 7.84733 20.9782 7.66341 21.1377 7.42578C21.3005 7.18815 21.4193 6.86589 21.4941 6.45898H22.5537V16H21.333V8.88086C21.1735 8.99154 21.0026 9.08268 20.8203 9.1543C20.6413 9.22591 20.4476 9.28451 20.2393 9.33008C20.0309 9.3724 19.8063 9.40495 19.5654 9.42773C19.3278 9.44727 19.0706 9.45866 18.7939 9.46191V8.33887ZM30.0537 6L26.0156 16.2002H24.9561L28.9551 6H30.0537ZM30.4248 9.83789C30.3857 9.33984 30.4313 8.8776 30.5615 8.45117C30.695 8.02474 30.9001 7.65527 31.1768 7.34277C31.4567 7.03027 31.8001 6.78613 32.207 6.61035C32.6172 6.43132 33.0762 6.3418 33.584 6.3418C34.0039 6.3418 34.3978 6.40527 34.7656 6.53223C35.1367 6.65592 35.459 6.83822 35.7324 7.0791C36.0091 7.31673 36.2272 7.61133 36.3867 7.96289C36.5462 8.3112 36.626 8.70996 36.626 9.15918C36.626 9.45215 36.5934 9.72233 36.5283 9.96973C36.4632 10.2171 36.3737 10.445 36.2598 10.6533C36.1458 10.8617 36.0124 11.0537 35.8594 11.2295C35.7096 11.402 35.5469 11.5632 35.3711 11.7129C35.1986 11.8594 35.0195 11.9961 34.834 12.123C34.6484 12.2467 34.4661 12.3656 34.2871 12.4795C34.0007 12.6618 33.7142 12.8473 33.4277 13.0361C33.1413 13.2249 32.8792 13.4202 32.6416 13.6221C32.404 13.8206 32.2038 14.0257 32.041 14.2373C31.8783 14.4456 31.7806 14.6605 31.748 14.8818H36.5479V16H30.1855C30.2181 15.6289 30.2783 15.292 30.3662 14.9893C30.4574 14.6865 30.5697 14.4098 30.7031 14.1592C30.8366 13.9085 30.9863 13.6807 31.1523 13.4756C31.3216 13.2673 31.5007 13.0768 31.6895 12.9043C31.8815 12.7285 32.0801 12.5658 32.2852 12.416C32.4902 12.2663 32.6969 12.1214 32.9053 11.9814C33.3187 11.7015 33.6751 11.4541 33.9746 11.2393C34.2773 11.0244 34.5247 10.8128 34.7168 10.6045C34.9089 10.3962 35.0505 10.1781 35.1416 9.9502C35.236 9.71908 35.2832 9.44889 35.2832 9.13965C35.2832 8.87923 35.2376 8.64648 35.1465 8.44141C35.0553 8.23307 34.93 8.05729 34.7705 7.91406C34.6143 7.76758 34.4287 7.65527 34.2139 7.57715C33.999 7.49902 33.7695 7.45996 33.5254 7.45996C33.1999 7.45996 32.9183 7.52832 32.6807 7.66504C32.443 7.7985 32.2477 7.97754 32.0947 8.20215C31.9417 8.4235 31.8311 8.67741 31.7627 8.96387C31.6943 9.24707 31.6683 9.53841 31.6846 9.83789H30.4248Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11485_6547",
    x: 17.7939,
    y: 6,
    width: 19.832,
    height: 12.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11485_6547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11485_6547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11485_6547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 22,
    rx: 11,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep12);
export default __webpack_public_path__ + "static/media/step1-2.221f54e2c570d9be98a5bd12ca115fb6.svg";
export { ForwardRef as ReactComponent };